import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

function ColorTextBox(props) {
    return (
        <>
            <PC>
                <div>
                    <div className="color-text-box-background" style={{ color: props.color }}>
                        {props.text}
                    </div>
                </div>
            </PC>
            <Notebook>
                <div>
                    <div className="color-text-box-background" style={{ color: props.color }}>
                        {props.text}
                    </div>
                </div>
            </Notebook>
            <Tablet>
                <div>
                    <div className="color-text-box-background" style={{ color: props.color }}>
                        {props.text}
                    </div>
                </div>
            </Tablet>
            <Mobile>
                <div>
                    <div className="color-text-box-background" style={{ color: props.color }}>
                        {props.text}
                    </div>
                </div>
            </Mobile>
        </>
    )
}

export default ColorTextBox
